import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    width: "90%",
    margin: "20px auto",
    marginBottom:"35px",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
    position: "relative",
    maxHeight: "440px",
    [theme.breakpoints.down(600)]: {
      width:'100%',
    },
  },
  tableContainer: {
    display: "grid",
    flexDirection: "column",
    maxHeight: "440px",
    overflowY: "auto",
    borderRadius: "10px",
    backgroundColor: "#fff",
    position: "relative",
  },
  tableContainer1: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "240px",
    overflowY: "auto",
    borderRadius: "10px",
    backgroundColor: "#fff",
    position: "relative",
  },
  headerRow: {
    fontWeight: "bold",
    backgroundColor: brandTheme.mainColor,
    color: "#ffffff",
    position: "sticky",
    top: 0,
    zIndex: 2,
     "&:hover": {
      backgroundColor: `${brandTheme.mainColor} !important`,
    },
  },
  row: {
    display: "flex",
    padding: "12px 16px",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    transition: "background-color 0.3s ease-in-out",
    cursor: "pointer",
    "&:nth-child(even)": {
      backgroundColor: "#f7f7f7",
    },
    "&:hover": {
      backgroundColor: "#e3e3e3",
    },
   [theme.breakpoints.down(600)]: {
      padding:'0px',
    },

  },
  cell: {
    flex: 1,
    padding: "8px 12px",
    textAlign: "left",
    fontSize: "14px",
    wordBreak:'break-word'
  },
  colorCell: {
    backgroundColor: "#fff",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    borderRadius: "5px",
    padding: "8px",
    textAlign: "center",
    fontWeight: "bold",
  },
  tableDataGreenRow:{
    display: "flex",
    padding: "12px 16px",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    transition: "background-color 0.3s ease-in-out",
    cursor: "pointer",
    backgroundColor:brandTheme?.rowColourBackground,
  },
tableDataRedRow:{
  display: "flex",
    padding: "12px 16px",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    transition: "background-color 0.3s ease-in-out",
    cursor: "pointer",
    backgroundColor:brandTheme?.rowRedColourBackground,
  },
}));

const ColumnGroupingTables = ({ columns, rows, onRowClick, styling, checkDate }) => {
  const classes = useStyles();

  return (
    <div className={classes.tableWrapper}>
      <div className={styling ? classes.tableContainer : classes.tableContainer}>
        {/* Table Header */}
        <div className={`${classes.row} ${classes.headerRow}`}>
          {columns.map((column) => (
            <div key={column.id} className={classes.cell} style={{minWidth:'120px'}}>
              {column.label}
            </div>
          ))}
        </div>

        {/* Table Rows */}
        {rows.map((row, index) => (
          <div 
            key={index} 
            style={{minWidth:'120px'}}
            className={
              checkDate ?
              (() => {
                let isPastDue = false;
                let isPaid = false;
                let isColour = false;
                Object.entries(row).forEach(([key, value]) => {
                  console.log(row,columns,key,'rowcolumns')
                  if (key === "paid") {
                    isPaid = value === "Yes"; // Ensure it's boolean
                  }
                  if(key=== "colourCheck"){
                    isColour = value;
                  }
                });
                if (isPaid && isColour) {
                  return classes.tableDataGreenRow; // Green if past due but paid
                }
                if (!isPaid && isColour) {
                  return classes.tableDataRedRow; // Red if past due and not paid
                }
                return classes?.row; // No class if conditions aren’t met
              })():
              classes?.row
            }
            onClick={() => onRowClick && onRowClick(row)}
          >
            {columns.map((column) => (
              <div
                key={column.id}
                className={column.id === "color" ? classes.colorCell : classes.cell}
                style={{minWidth:'120px'}}
              >
                {row[column.id]}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnGroupingTables;
